import { createApp } from '@app/adapters/create-app'
import PeriodPickerTrigger from '@app/application/layout/components/period-picker-trigger.vue'

export default (doc: Document): void => {
  const triggers = doc.querySelectorAll(
    "[data-behaviour='period-picker-trigger']"
  )

  triggers.forEach((trigger, key) => {
    const triggerElement = trigger as HTMLElement
    const app = createApp(
      PeriodPickerTrigger,
      {
        period: triggerElement.dataset.period,
        setCurrentLedger: triggerElement.dataset.setCurrentLedger === 'true',
        url: triggerElement.dataset.url,
      },
      {
        singletonId: `period-picker-trigger-${key}`,
      }
    )

    app.mount(triggerElement)
  })
}
